import { Store } from "lucide-react";
import { useAuth } from "../lib/auth";

export const openStoreSwitcher = () => window.dispatchEvent(new Event("jatak:open-store-switcher"));

export function PickupShopLabel({ multi }) {
  const { store } = useAuth();
  const name = store?.name || "";
  return (
    <div className={"pickup-shop" + (multi ? " multi" : "")} data-testid="pickup-shop-label">
      <Store size={16} aria-hidden="true" />
      <span className="psh-txt" title={name} tabIndex={0}>
        Udlevering · <b data-testid="pickup-shop-name">{name}</b>
      </span>
      {multi && (
        <button type="button" className="psh-switch" onClick={openStoreSwitcher} data-testid="pickup-switch-store">
          Skift butik
        </button>
      )}
    </div>
  );
}

export function ElsewhereNotice({ other, canSwitch, onClose }) {
  const { switchStore } = useAuth();
  if (!other) return null;
  return (
    <div className="notice warn pickup-elsewhere" role="alert" data-testid="pickup-elsewhere">
      <span>
        Koden hører til <b>{other.name}</b>.
      </span>
      <span className="pe-actions">
        {canSwitch && (
          <button className="btn small primary" onClick={() => switchStore(other.id)} data-testid="pickup-elsewhere-switch">
            Skift til {other.name}
          </button>
        )}
        <button className="btn small" onClick={onClose} data-testid="pickup-elsewhere-close">
          Luk
        </button>
      </span>
    </div>
  );
}
